export default {
  SUCCESS: {
    PASSWORD_CHAGNED: "パスワード変更しました、もう一回ログインしてみてください。",
    ORDER_APPROVED: '注文書・注文請書は承認しました。',
    REQUEST_APPROVED: '支払通知書・請求書は承認しました。',
    NOTIFICATION_CONFIRMED: 'お知らせ内容を確認しました。',
  },
  INFO: {
    NO_DATA: 'レコードがありません。',
  },
  VALIDATION: {
    REQUIRED: 'この項目は必須です。',
    INVALID_EMAIL: '有効なメールアドレスではありません。',
    PASSWORD_CONFIRM: '新パスワードと新パスワード（確認）は一致しません。',
    MIN_LENGTH: (limit: string) => `${limit}文字以上入力してください。`,
    MAX_LENGTH: (limit: string) => `${limit}文字以内で入力してください。`,
  },
  CONFIRM: {
    APPROVAL: '承認します、よろしいですか？',
    CONFIRMED: '確認済にします、よろしいですか？',
  },
  ERROR: {
    NETWORK: "サーバーに繋がらない、システム管理者にご連絡ください。",
    NOTFOUND: '見つかりませんでした。',
    START_YM: "EDI使用開始年月より前の日付に参照できません。",
  },
}